import { render, staticRenderFns } from "./VoteWenJuan.vue?vue&type=template&id=2fd105eb"
import script from "./VoteWenJuan.vue?vue&type=script&lang=js"
export * from "./VoteWenJuan.vue?vue&type=script&lang=js"
import style0 from "./VoteWenJuan.vue?vue&type=style&index=0&id=2fd105eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports